import { gql } from '@apollo/client'
import { mediaUploadFieldsFragment } from 'modules/media-uploads/queries/mediaUploadFields'
import { storyFragment } from 'modules/stories/queries/story'

export const reviewTagsFragment = gql`
  fragment ReviewTagFields on Review {
    tags {
      id
      slug
      name
    }
  }
`

export const reviewFragment = gql`
  ${reviewTagsFragment}
  ${storyFragment}
  ${mediaUploadFieldsFragment}
  fragment ReviewFields on Review {
    id
    bodyPositive
    bodyNegative
    bodyPrivate
    stars
    affiliation
    wouldRecommend
    clapCount
    replyCount
    readsCount
    brand {
      id
      title
      slug
      primaryImageFullPath
    }
    createdAt
    publishedAt
    mediaUploadIds
    tagIds
    isEditable
    media {
      ...MediaUploadFields
    }
    author {
      id
      fullName
      firstName
      avatarFullPath
      membershipLevel
      verificationStatus
      username
      reviewCount
      achievements {
        id
        type
      }
    }
    linkedStory {
      ...StoryFields
    }
    ...ReviewTagFields
  }
`

export const reviewSummaryFragment = gql`
  fragment ReviewSummaryFields on ReviewSummary {
    brandId
    averageRating
    ratingsCount
    wouldRecommendPercent
    ratingDistribution
    popularTags {
      id
      name
      slug
    }
  }
`
